import { Toaster } from "sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustMarquee } from "@/components/site/TrustMarquee";
import { Services } from "@/components/site/Services";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Testimonials } from "@/components/site/Testimonials";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Faq } from "@/components/site/Faq";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Toaster position="top-center" richColors />
      <Navbar />
      <Hero />
      <TrustMarquee />
      <Services />
      <BeforeAfter />
      <WhyChooseUs />
      <Testimonials />
      <ServiceArea />
      <Faq />
      <FinalCTA />
      <Footer />
    </main>
  );
}
